// P2-42: first-order offer (snippets/tbs-offer.liquid, tbs-offer-line.liquid, tbs-offer-state.liquid).
// The page state lives on <html data-tbs-offer>, set in <head> before the first paint:
//   invite  - not signed up: the top bar, the product price line and the bag line open the sign-up sheet;
//   code    - signed up: the code shows and "Apply" puts it in the bag;
//   applied - the code is in the bag, or goes in with the first item;
//   off     - first order placed (the bag that carried the code was replaced by a new one), or B2B.
// CSS shows the words of the current state ([data-when]); this script moves between states, runs the sheet, applies
// the code through the Cart API (/cart/update.js, discount) and keeps the amounts right after variant and bag changes.
// localStorage "tbs-offer": s signed up (time), a apply asked, t token of the bag that carried the code,
// o first order placed, d last time the sheet opened by itself.
(function () {
  var root = document.documentElement;
  var dialog = document.getElementById('TbsOffer');
  var configNode = document.getElementById('TbsOfferConfig');
  if (!dialog || !configNode) return;

  var config = JSON.parse(configNode.textContent);
  var KEY = 'tbs-offer';
  var DAY = 864e5;
  var form = dialog.querySelector('form');
  var email = dialog.querySelector('input[type="email"]');
  var error = dialog.querySelector('[data-tbs-offer-error]');
  var applying = false;

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  }
  function save(patch) {
    var next = Object.assign(load(), patch);
    try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) {}
    return next;
  }
  function current() { return root.getAttribute('data-tbs-offer') || 'invite'; }
  function setState(next) {
    var now = current();
    if (now === 'off' || now === next) return;
    root.setAttribute('data-tbs-offer', next);
    document.querySelectorAll('[data-tbs-offer-line]').forEach(function (line) {
      line.classList.remove('is-new');
      void line.offsetWidth;
      line.classList.add('is-new');
    });
  }
  function money(cents) {
    if (typeof formatMoney === 'function' && window.MinimogSettings) return formatMoney(cents, MinimogSettings.money_format);
    return '$' + (cents / 100).toFixed(2);
  }
  function publish(name) {
    try { window.Shopify.analytics.publish('tbs_offer_' + name, { code: config.code }); } catch (e) {}
  }
  function rootUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function tokenOf(cart) { return String(cart.token || '').split('?')[0]; }

  // Bag ---------------------------------------------------------------------------------------------------------

  function getCart() {
    return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function codeStatus(cart) {
    var hit = (cart.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === config.code; })[0];
    if (!hit) return '';
    return hit.applicable ? 'applied' : 'blocked';
  }
  function savingOf(cart) {
    var own = (cart.cart_level_discount_applications || []).reduce(function (sum, d) {
      return String(d.title).toUpperCase() === config.code ? sum + d.total_allocated_amount : sum;
    }, 0);
    return own || Math.round((cart.items_subtotal_price * config.percent) / 100);
  }
  function renderBag(cart, status) {
    var saving = savingOf(cart);
    document.querySelectorAll('[data-tbs-offer-line="bag"]').forEach(function (line) {
      line.hidden = cart.item_count === 0 || status === 'blocked';
      line.querySelectorAll('[data-tbs-saving]').forEach(function (el) { el.textContent = money(saving); });
      var note = line.querySelector('[data-tbs-ship-note]');
      if (!note) return;
      // The free shipping threshold is compared with the total after discounts: say what keeps it with the code.
      var threshold = Number(line.dataset.threshold) || 0;
      var need = 0;
      if (threshold > 0 && status !== 'applied' && cart.total_price >= threshold && cart.total_price - saving < threshold) {
        need = Math.ceil((threshold * 100) / (100 - config.percent)) - cart.total_price;
      }
      note.hidden = need <= 0;
      if (need > 0) {
        note.textContent = note.dataset.text
          .replace('[threshold]', money(threshold).replace(/[.,]00(?=\D*$)/, ''))
          .replace('[amount]', money(need));
      }
    });
  }
  function onCart(cart, noApply) {
    var s = load();
    var status = codeStatus(cart);
    var token = tokenOf(cart);
    if (s.t && token && s.t !== token && status !== 'applied') {
      // The bag that carried the code is gone: Shopify starts a new bag once an order is placed.
      save({ o: 1, a: 0 });
      root.setAttribute('data-tbs-offer', 'off');
      return;
    }
    if (status === 'applied') {
      if (cart.item_count > 0) save({ a: 1, t: token });
      setState('applied');
    } else if (status === 'blocked') {
      save({ a: 0, t: '' });
      if (current() === 'applied') setState('code');
    } else if (s.a && s.t === token) {
      // The shopper took the code off the bag.
      save({ a: 0, t: '' });
      setState('code');
    } else if (s.a && !noApply && cart.item_count > 0 && !(cart.discount_codes || []).length && config.showCode) {
      // Asked for before the first item: it goes in now.
      applyCode();
      return;
    } else if (current() === 'applied' && !s.a) {
      setState('code');
    }
    renderBag(cart, status);
  }
  function refreshTheme() {
    var drawer = document.querySelector('m-cart-drawer');
    if (drawer && typeof drawer.onCartDrawerUpdate === 'function') drawer.onCartDrawerUpdate();
    var page = document.querySelector('m-cart');
    if (page && typeof page.onCartUpdate === 'function') page.onCartUpdate();
  }
  function setBusy(on) {
    document.querySelectorAll('[data-tbs-offer-apply]').forEach(function (button) {
      if (on) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    });
  }
  function applyCode() {
    if (applying) return Promise.resolve(null);
    applying = true;
    setBusy(true);
    save({ a: 1, s: load().s || Date.now() });
    return fetch(rootUrl() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: config.code }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        publish('apply');
        if (!cart || typeof cart.item_count !== 'number' || cart.item_count === 0) {
          // Empty bag: the code goes in with the first item.
          setState('applied');
          return cart;
        }
        onCart(cart, true);
        refreshTheme();
        return cart;
      })
      .catch(function () {
        setState('applied');
        return null;
      })
      .finally(function () {
        applying = false;
        setBusy(false);
      });
  }

  var refreshTimer;
  function refreshSoon() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      if (applying) return;
      getCart().then(function (cart) { onCart(cart); }).catch(function () {});
    }, 300);
  }
  if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, refreshSoon);
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, refreshSoon);
  }
  document.addEventListener('cart:updated', refreshSoon);

  // Product price line: follow the selected variant (product page and quick view).
  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    document.querySelectorAll('[data-tbs-offer-line="product"]').forEach(function (line) {
      if ((',' + line.dataset.variants + ',').indexOf(',' + variant.id + ',') === -1) return;
      line.hidden = !variant.price;
      var price = Math.round((variant.price * (100 - config.percent)) / 100);
      line.querySelectorAll('[data-tbs-price]').forEach(function (el) { el.textContent = money(price); });
    });
  });

  // Sign-up sheet --------------------------------------------------------------------------------------------------

  function open(step, reason) {
    dialog.setAttribute('data-step', step);
    dialog.setAttribute('aria-labelledby', step === 'done' ? 'TbsOfferDoneTitle' : 'TbsOfferTitle');
    if (!dialog.open) {
      dialog.showModal();
      root.classList.add('prevent-scroll');
    }
    publish(step === 'done' ? 'reveal' : 'open_' + (reason || 'click'));
  }
  function close() {
    if (dialog.open) dialog.close();
  }
  dialog.addEventListener('close', function () {
    // Also fired after the switch out of modal mode on sending (the sheet is open again by then).
    if (dialog.open) return;
    dialog.classList.remove('is-sending');
    form.querySelector('[type="submit"]').removeAttribute('aria-busy');
    if (!document.querySelector('m-cart-drawer.m-cart-drawer--active')) root.classList.remove('prevent-scroll');
  });
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog || event.target.closest('[data-tbs-offer-close]')) close();
  });

  function showError(text) {
    error.hidden = !text;
    error.textContent = text;
    email.setAttribute('aria-invalid', text ? 'true' : 'false');
  }
  function signedUp() {
    if (current() === 'off') return;
    save({ s: Date.now() });
    if (current() === 'invite') setState('code');
    publish('signup');
    open('done');
  }
  // A wrong address is stopped by the browser before Shopify starts its captcha; the message is ours.
  email.addEventListener('invalid', function (event) {
    event.preventDefault();
    showError(config.text.invalid);
  });
  email.addEventListener('input', function () {
    if (!error.hidden && email.validity.valid) showError('');
  });
  // The form is sent the usual way: Shopify adds its hCaptcha token, then posts it, and the page comes back with
  // customer_posted=true, where the sheet opens on the code. Out of modal mode while it is sent, so a captcha puzzle,
  // when Shopify asks for one, can be answered (a modal sheet makes the rest of the page inert).
  form.addEventListener('submit', function () {
    showError('');
    var submit = form.querySelector('[type="submit"]');
    submit.setAttribute('aria-busy', 'true');
    if (dialog.open) {
      dialog.close();
      dialog.show();
    }
    dialog.classList.add('is-sending');
    publish('submit');
  });

  document.addEventListener('click', function (event) {
    var signup = event.target.closest('[data-tbs-signup]');
    if (signup) {
      event.preventDefault();
      if (current() !== 'off') open(current() === 'invite' ? 'form' : 'done');
      return;
    }
    var apply = event.target.closest('[data-tbs-offer-apply]');
    if (apply) {
      event.preventDefault();
      var inSheet = dialog.contains(apply);
      applyCode().then(function (cart) {
        if (!inSheet || !cart || !cart.item_count) return;
        // From the sheet with items in the bag: show the saving where it happens.
        close();
        var drawer = document.querySelector('m-cart-drawer');
        if (drawer && typeof drawer.open === 'function' && window.MinimogSettings && MinimogSettings.enable_cart_drawer) drawer.open();
      });
      return;
    }
    var copy = event.target.closest('[data-tbs-offer-copy]');
    if (copy && navigator.clipboard) {
      event.preventDefault();
      var label = copy.querySelector('[data-tbs-offer-copy-label]');
      navigator.clipboard.writeText(config.code).then(function () {
        if (!label) return;
        var before = label.textContent;
        label.textContent = config.text.copied;
        setTimeout(function () { label.textContent = before; }, 2000);
      }).catch(function () {});
    }
  });

  // Floating coupon ------------------------------------------------------------------------------------------------
  // Never on the first screen (it would cover the product title and price): it comes after some scrolling or once
  // the sheet is closed. Folds to its "10%" stub while the page scrolls down, sits above the sticky Add to cart bar, the
  // preview bar and the cookie banner (EU and UK visitors), hides for 7 days with its cross. CSS hides it once the code is in the bag (data-when).

  var coupon = document.querySelector('[data-tbs-coupon]');
  var revealCoupon = function () {};
  if (coupon) {
    var placing = false;
    var lastY = window.scrollY;
    var idleTimer;
    var place = function () {
      placing = false;
      var gap = window.matchMedia('(min-width: 768px)').matches ? 24 : 16;
      ['.m-sticky-addtocart', '#PBarNextFrameWrapper', '#m-cookie-banner'].forEach(function (selector) {
        var bar = document.querySelector(selector);
        if (!bar) return;
        var r = bar.getBoundingClientRect();
        var cs = getComputedStyle(bar);
        if (cs.display === 'none' || cs.visibility === 'hidden' || r.height === 0 || r.top >= window.innerHeight) return;
        gap = Math.max(gap, Math.round(window.innerHeight - r.top + 12));
      });
      coupon.style.setProperty('--tbs-coupon-bottom', gap + 'px');
    };
    var placeSoon = function () {
      if (placing) return;
      placing = true;
      requestAnimationFrame(place);
    };
    revealCoupon = function () {
      if (!coupon.hidden) return;
      var s = load();
      if (s.x && Date.now() - s.x < 7 * DAY) return;
      place();
      coupon.hidden = false;
      publish('coupon_shown');
    };
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (coupon.hidden && y > window.innerHeight * 0.6) revealCoupon();
      if (y > lastY + 8) coupon.classList.add('is-mini');
      else if (y < lastY - 8) coupon.classList.remove('is-mini');
      lastY = y;
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () { coupon.classList.remove('is-mini'); }, 900);
      placeSoon();
    }, { passive: true });
    window.addEventListener('resize', placeSoon);
    coupon.querySelector('[data-tbs-coupon-close]').addEventListener('click', function () {
      save({ x: Date.now() });
      coupon.hidden = true;
      publish('coupon_hidden');
    });
  }
  dialog.addEventListener('close', function () {
    if (dialog.open) return;
    // Seen and closed: no opening by itself for 14 days; the coupon takes over.
    if (dialog.getAttribute('data-step') === 'form' && !load().d) save({ d: Date.now() });
    // P2-44: never on the first screen, closed sheet or not (it covered the product title and price); higher up
    // the page, the scroll handler shows it once the shopper scrolls.
    if (window.scrollY > window.innerHeight * 0.6) revealCoupon();
  });

  // On load --------------------------------------------------------------------------------------------------------

  var params = new URLSearchParams(location.search);
  if (params.get('customer_posted') === 'true') {
    // Back from a sign-up sent the usual way (footer form, or this sheet after a captcha).
    params.delete('customer_posted');
    var query = params.toString();
    history.replaceState(history.state, '', location.pathname + (query ? '?' + query : ''));
    signedUp();
  } else if (!error.hidden && error.textContent.trim()) {
    open('form');
  }

  var stored = load();
  if (stored.a || stored.t) refreshSoon();

  function autoOpen(reason) {
    if (current() !== 'invite' || dialog.open || document.visibilityState !== 'visible') return;
    if (document.querySelector('m-cart-drawer.m-cart-drawer--active, dialog[open]')) return;
    var s = load();
    if (s.d && Date.now() - s.d < 14 * DAY) return;
    save({ d: Date.now() });
    open('form', reason);
  }
  if (config.auto && config.delay > 0 && current() === 'invite') {
    setTimeout(function () { autoOpen('timer'); }, config.delay * 1000);
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      // Desktop: also when the pointer leaves the window by the top, after a few seconds on the page.
      setTimeout(function () {
        document.addEventListener('mouseout', function (event) {
          if (!event.relatedTarget && event.clientY <= 0) autoOpen('exit');
        });
      }, 5000);
    }
  }
})();
